<style scoped lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/supplier/page" getKey="rows"
			:columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('gongyingshangbianma')">
						<el-input v-model="yt.conditions.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('gongyingshangmingcheng')">
						<el-input v-model="yt.conditions.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('gongyingshangdizhi')">
						<el-input v-model="yt.conditions.address"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain="plain">
							{{ $t('sousuo') }}
						</el-button>
						<el-button @click="yt.clear()">{{ $t('chongzhi') }}
						</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<template #buttonsL>
				<el-button size="mini" v-if="utils.checkPower('web_wms_supplier_create')"
					@click="yt.showEditDialog('xinzeng', null, 'w1'); setDefaultValue()" type="primary">
					{{ $t('xinzeng') }}
				</el-button>
				<el-button size="mini" @click="show = !show" plain>
					{{ $t('daoru') }}
				</el-button>
			</template>
			<template #buttonsR>
				<el-button :loading="exportExcelLoading" size="mini" icon="yicon yicon-export" :title="$t('daochu')"
					@click="exportExcel()"></el-button>
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"
					@click="yt.showColumnsDialog()"></el-button>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('xiangqing', scope.row, '60%')">{{ $t('xiangqing')
						}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button v-if="utils.checkPower('web_wms_supplier_update')" type="text"
							@click="yt.showEditDialog('bianji', scope.row)">{{ $t('bianji') }}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button v-if="utils.checkPower('web_wms_supplier_delete')" type="text" class="font-color-danger"
							@click="yt.remove(scope.row, '/web/supplier/delete')">
							{{ $t('shanchu') }}
						</el-button>
					</el-col>
				</el-row>
			</template>
			<!-- 底部插槽 -->
			<template #footer>
			</template>
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body>
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('gongyingshangbianma')" required>
						<el-input v-model="yt.editObj.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('gongyingshangmingcheng')" required>
						<el-input v-model="yt.editObj.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('gongyingshangdizhi')" required>
						<el-input v-model="yt.editObj.address"></el-input>
					</el-form-item>
					<el-form-item :label="$t('lianxiren')">
						<el-input v-model="yt.editObj.contacts"></el-input>
					</el-form-item>
					<el-form-item :label="$t('lianxifangshi')">
						<el-input v-model="yt.editObj.contactsInfo"></el-input>
					</el-form-item>
					<el-form-item :label="$t('youxiang')">
						<el-input v-model="yt.editObj.email"></el-input>
					</el-form-item>
					<el-form-item :label="$t('shifouqiyong')" required>
						<el-select v-model="yt.editObj.enable">
							<el-option :label="$t('fou')" :value="'0'"></el-option>
							<el-option :label="$t('shi')" :value="'1'"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
					<el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/supplier/create')"
						type="primary">
						{{ $t('baocun') }}
					</el-button>
				</span>
			</template>


			<!-- 更新表单 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('gongyingshangbianma')" required>
						<el-input v-model="yt.editObj.code" disabled></el-input>
					</el-form-item>
					<el-form-item :label="$t('gongyingshangmingcheng')" required>
						<el-input v-model="yt.editObj.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('gongyingshangdizhi')" required>
						<el-input v-model="yt.editObj.address"></el-input>
					</el-form-item>
					<el-form-item :label="$t('lianxiren')">
						<el-input v-model="yt.editObj.contacts"></el-input>
					</el-form-item>
					<el-form-item :label="$t('lianxifangshi')">
						<el-input v-model="yt.editObj.contactsInfo"></el-input>
					</el-form-item>
					<el-form-item :label="$t('youxiang')">
						<el-input v-model="yt.editObj.email"></el-input>
					</el-form-item>
					<el-form-item :label="$t('shifouqiyong')" required>
						<el-select v-model="yt.editObj.enable">
							<el-option :label="$t('fou')" :value="'0'"></el-option>
							<el-option :label="$t('shi')" :value="'1'"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
					<el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/supplier/update')"
						type="primary">
						{{ $t('baocun') }}
					</el-button>
				</span>
			</template>
			<!-- 详情 -->
			<template v-if="yt.editObj.action == 'xiangqing'">
				<div class="dialog-scroller" style="display: flex;flex-direction: column;">
					<div>

						<el-descriptions direction="horizontal" :column="3" border>
							<el-descriptions-item :label="$t('gongyingshangbianma')">{{ yt.editObj.code }}
							</el-descriptions-item>
							<el-descriptions-item :label="$t('gongyingshangmingcheng')">
								{{ yt.editObj.name }}
							</el-descriptions-item>
							<el-descriptions-item :label="$t('gongyingshangdizhi')" :span="2"> {{ yt.editObj.address }}
							</el-descriptions-item>
							<el-descriptions-item :label="$t('lianxiren')">
								{{ yt.editObj.contacts }}
							</el-descriptions-item>
							<el-descriptions-item :label="$t('lianxifangshi')">{{ yt.editObj.contactsInfo
							}}</el-descriptions-item>
							<el-descriptions-item :label="$t('youxiang')"> {{ yt.editObj.email }}</el-descriptions-item>
						</el-descriptions>
					</div>
					<div>
						<el-tabs v-model="currentTab" style="height: 100%;" @tab-click="handleClick">
							<el-tab-pane :label="$t('wuliaoxinxi')" name="wuliaoxinxi">
							</el-tab-pane>
						</el-tabs>
					</div>
					<div style="flex: 1;">
						<y_details v-show="currentTab == 'wuliaoxinxi'" :suppliers="yt.editObj"></y_details>
			
					</div>
				

				</div>

			</template>

		</el-dialog>
		<!-- 导入excel -->
		<importExcel :show.sync="show" />


	</div>
</template>
<script type="text/javascript">
import importExcel from './import_excel'
import y_details from './details'
export default {
	name: 'wms_wms_supplier_list',
	components: {
		importExcel,
		y_details
	},

	data() {
		return {
			currentTab: 'wuliaoxinxi',
			show: false,
			exportExcelLoading: false,
			columns: [{
				label: 'gongyingshangbianma',
				prop: 'code',
				width: 150,
			},
			{
				label: 'gongyingshangmingcheng',
				prop: 'name'
			},
			{
				label: 'gongyingshangdizhi',
				prop: 'address'
			},
			{
				label: 'lianxiren',
				prop: 'contacts',
			},
			{
				label: 'lianxifangshi',
				prop: 'contactsInfo',
			},
			{
				label: 'youxiang',
				prop: 'email',
			},
			{
				label: 'chuangjianren',
				prop: 'createByObject.nickname',
			},
			{
				label: 'chuangjianshijian',
				prop: 'createTime',
				type: 'time'
			},
			{
				label: 'caozuo',
				type: 'slot',
				width: 180,
				fixed: 'right',
			},
			],
		};

	},

	created() {
		setTimeout(() => {
			this.yt.get(1);
			this.utils.event_hub.$on('WAREHOUSE_SUPPLIER_REFRESH', () => {
				this.yt.get(1);
			});
			this.yt.get(1)
		}, 300)

	},
	methods: {
		handleClick(tab, event) {
			console.log(this.currentTab);
		},
		setDefaultValue() {
			this.yt.editObj.enable = '1';
		},
		exportExcel() {
			this.exportExcelLoading = true
			let params = this.yt.conditions
			return this.http.get('/web/report/export/supplier_export', {
				params
			}).then(res => {
				this.$message.success(this.$t(res.msg))
				this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG')
				this.exportExcelLoading = false
			}).catch(error => {
				this.$message.error(this.$t(error))
				this.exportExcelLoading = false
			})
		},
	},
};
</script>
